export { XEmbed as Embed } from './X';
